import {resolvePeriod} from '@ozon-ai/periods';
import {CompetitorAnalysisPanel} from './competitor-analysis-panel';
import {useProductPageContext} from './product-context';

export function CompetitorsSummaryPage() {
	const state = useProductPageContext();
	const sharedPeriod = sharedRange(state);
	return <CompetitorAnalysisPanel offerId={state.offerId} view="summary" sharedPeriod={sharedPeriod}/>;
}

export function sharedRange(state: ReturnType<typeof useProductPageContext>): {from: string; to: string} | null {
	if (!state.period.selection) return null;
	try {
		return resolvePeriod(state.period.selection, state.period.latestDay);
	} catch {
		return null;
	}
}
